import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const UpdateTimeFrameInformation = createAsyncThunk(
  "TimeFrameInformation/UpdateTimeFrameInformation",
  async (parameters, { rejectWithValue }) => {
    console.log(parameters,"makejjejjejej");
    
    try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
            "api/SU_NT_WPB_TimeFrameInformationServices/UpdateBI_TimelineInformation",
            parameters
          );

          const data = response.data.result; // Assuming response has a "data" field
          return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetBI_TimelineInformation = createAsyncThunk(
    "TimeFrameInformation/GetBI_TimelineInformation",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_TimeFrameInformationServices/GetBI_TimelineInformation",
              {
                applicationInformationId:parameters
              }
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );



const TimeFrameInformationReducers = createSlice({
  name: "FetchDataJson",
  initialState: {
    UpdateTimeFrameInformation: {},
    loadingUpdateTimeFrameInformation: false,
    errorUpdateTimeFrameInformation: null,

    TimeFrameInformation: {},
    loadingTimeFrameInformation: false,
    errorTimeFrameInformation: null,

    Validation: null,
  },
  reducers: {
    SetBI_TimelineInformation: (state, action) => {
      state.TimeFrameInformation = action.payload;
    },

    SetValidation:(state,action)=>{
      state.Validation=action.payload
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(UpdateTimeFrameInformation.pending, (state, action) => {
        state.loadingUpdateTimeFrameInformation = true;
        state.UpdateTimeFrameInformation = action.payload;
        state.errorUpdateTimeFrameInformation = null;
      })
      .addCase(UpdateTimeFrameInformation.fulfilled, (state, action) => {
        state.loadingUpdateTimeFrameInformation = false;
        state.UpdateTimeFrameInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateTimeFrameInformation.rejected, (state, action) => {
        state.loadingUpdateTimeFrameInformation = false;
        state.errorUpdateTimeFrameInformation = action.payload;
      });

      builder
      .addCase(GetBI_TimelineInformation.pending, (state, action) => {
        state.loadingTimeFrameInformation = true;
        state.TimeFrameInformation = action.payload;
        state.errorTimeFrameInformation = null;
      })
      .addCase(GetBI_TimelineInformation.fulfilled, (state, action) => {
        state.loadingTimeFrameInformation = false;
        state.TimeFrameInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetBI_TimelineInformation.rejected, (state, action) => {
        state.loadingTimeFrameInformation = false;
        state.errorTimeFrameInformation = action.payload;
      });
  },
});





export const { SetBI_TimelineInformation,SetValidation } = TimeFrameInformationReducers.actions;

export default TimeFrameInformationReducers.reducer;
